var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c(_vm.layoutComponent,_vm._b({tag:"component"},'component',_vm.layoutProps,false),[_c('template',{slot:"field"},[(!_vm.highlight)?_c('textarea',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.fieldValue),expression:"fieldValue"}],staticClass:"form-control",class:[
        'form-control',
        _vm.errorClasses,
        _vm.depends ? 'depend-textarea' : ''
      ],attrs:{"id":_vm.field.attribute,"cols":_vm.inputCols,"rows":_vm.inputRows,"maxlength":_vm.inputMaxlength,"placeholder":_vm.inputPlaceholder,"readonly":_vm.isReadonly,"disabled":_vm.isDisabled},domProps:{"value":(_vm.fieldValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fieldValue=$event.target.value}}},'textarea',_vm.field.attrs,false)):_c('AceEditor',{attrs:{"options":{
        enableBasicAutocompletion: true,
        enableLiveAutocompletion: true,
        fontSize: 12,
        wrap: true,
        indentedSoftWrap: false,
        highlightActiveLine: true,
        enableSnippets: true,
        showLineNumbers: true,
        tabSize: 2,
        showPrintMargin: false,
        showGutter: true,
        maxLines: Infinity,
        minLines: 5
      },"lang":_vm.highlight,"theme":"xcode","width":"100%"},on:{"init":_vm.editorInit},model:{value:(_vm.fieldValue),callback:function ($$v) {_vm.fieldValue=$$v},expression:"fieldValue"}}),(_vm.inputMaxlength && _vm.fieldValue && _vm.fieldValue.length)?_c('div',{staticClass:"maxlength_dump"},[_vm._v(" "+_vm._s(_vm.fieldValue.length)+"/"+_vm._s(_vm.inputMaxlength)+" ")]):_vm._e()],1)],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }